gx-drop-table-area {
    $gx-placeholder-color: var(--color-accent-primary-default);
    $gx-placeholder-width: 4px;

    position: relative;

    & .cell {

        position: absolute;

        //border: lightgray 1px dashed;

        & .cell-content {
            position: relative;
            height: 100%;

            [data-active] {
                background-color: var(--gx-place-holder-color, $gx-placeholder-color);
            }

            [data-place-holder="inside"] {
                position: absolute;
                z-index: 10000;
                left: var(--gx-le-table-placeholder-width, $gx-placeholder-width);
                right: var(--gx-le-table-placeholder-width, $gx-placeholder-width);
                top: var(--gx-le-table-placeholder-width, $gx-placeholder-width);
                bottom: var(--gx-le-table-placeholder-width, $gx-placeholder-width);

                [data-place-holder-marker] {
                    pointer-events: none;
                    width: 100%;
                    height: 100%;
                }
            }

            [data-place-holder="left"] {
                position: absolute;
                z-index: 8000;
                left: -1px;
                top: 0px;
                bottom: 0px;
                width: 50%;                

                [data-place-holder-marker] {
                    position: absolute;
                    pointer-events: none;
                    left: 0px;
                    top: 0px;
                    bottom: 0px;
                    width: var(--gx-le-table-placeholder-width, $gx-placeholder-width);
                }
            }

            [data-place-holder="right"] {
                position: absolute;
                z-index: 8000;
                right: -1px;
                top: 0px;
                bottom: 0px;
                width: 50%;                

                [data-place-holder-marker] {
                    position: absolute;
                    pointer-events: none;
                    right: 0px;
                    top: 0px;
                    bottom: 0px;
                    width: var(--gx-le-table-placeholder-width, $gx-placeholder-width);
                }
            }

            [data-place-holder="top"] {
                position: absolute;
                z-index: 9000;
                left: 0px;
                right: 0px;
                top: 0px;
                height: 25%;

                [data-place-holder-marker] {
                    position: absolute;
                    pointer-events: none;
                    left: 0px;
                    right: 0px;
                    top: 0px;
                    height: var(--gx-le-table-placeholder-width, $gx-placeholder-width);
                }
            }

            [data-place-holder="bottom"] {
                position: absolute;
                z-index: 9000;
                left: -1px;
                right: -1px;
                bottom: 0px;
                height: 25%;

                [data-place-holder-marker] {
                    position: absolute;
                    pointer-events: none;
                    left: 0px;
                    right: 0px;
                    bottom: 0px;
                    height: var(--gx-le-table-placeholder-width, $gx-placeholder-width);
                }
            }
        }
    }
}